import { httpInterceptor } from '../http-interceptor';

export class InventoryScanningService {
  static ENDPOINTS = {
    SAVE: 'Inventory/saveInventoryScanning',
    GET_ALL: 'Inventory/getInventoryScanning',
    GET_AUDITS: 'Inventory/getinventoryaudits',
    SAVE_BATCH: 'Inventory/saveInventoryScanningBatch',
    GET_BY_AUDIT_LOCATION: 'Inventory/getInventoryScanningByAuditLocation',
  };

  static async saveInventoryScanning(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE, data);
  }

  static async getInventoryScanning(filters = {}) {
    return httpInterceptor.post(this.ENDPOINTS.GET_ALL, filters);
  }

  static async getInventoryAudits() {
    return httpInterceptor.post(this.ENDPOINTS.GET_AUDITS, null);
  }

  static async saveInventoryScanningBatch(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_BATCH, data);
  }

  static async getInventoryScanningByAuditLocation(data) {
    return httpInterceptor.post(this.ENDPOINTS.GET_BY_AUDIT_LOCATION, data);
  }
}

